var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCita(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "55px",
    height: "55px",
    viewBox: "0 0 55 55",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8.2 Cita") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.10Reservaciones",
    transform: "translate(-468.000000, -420.000000)",
    stroke: "#FE8D27",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(469.000000, 208.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-39",
    transform: "translate(0.000000, 204.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8.2-Cita",
    transform: "translate(0.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 26.5,
    cy: 26.5,
    r: 26.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "3.1Fecha",
    transform: "translate(15.500000, 16.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 1,
    y: 2.05263158,
    width: 19.0526316,
    height: 16.9473684,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 7.36842105,
    x2: 1.05263158,
    y2: 7.36842105,
    id: "Path-2",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.31578947,
    y1: 4.21052632,
    x2: 6.31578947,
    y2: 0,
    id: "Path-17",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.7368421,
    y1: 4.21052632,
    x2: 14.7368421,
    y2: 0,
    id: "Path-17",
    strokeLinecap: "round"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCita);
export default __webpack_public_path__ + "static/media/Cita.3b9f74244e8d3851a3778130a05d408e.svg";
export { ForwardRef as ReactComponent };